module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e1967"
    }
  }, [_c('span', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2017"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c16_r1#d7e1",
      "id": "d6e1"
    }
  }, [_c('i', [_vm._v("A Note from the Editor ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e2067"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c17_r1#d7e2",
      "id": "d6e2"
    }
  }, [_c('i', [_vm._v("Introduction ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2117"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c18_r1#d7e3",
      "id": "d6e3"
    }
  }, [_vm._v("Chapter One: An American Citizen")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2167"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c19_r1#d7e4",
      "id": "d6e4"
    }
  }, [_vm._v("Chapter Two: Light Horse Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2227"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c20_r1#d7e5",
      "id": "d6e5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Three: Making of a Gentleman")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2277"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c21_r1#d7e6",
      "id": "d6e6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Four: Dear Mary")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2327"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c22_r1#d7e7",
      "id": "d6e7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Five: A Duty Imposed")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2377"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c23_r1#d7e8",
      "id": "d6e8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Six: Mississippi Mud")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2427"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c24_r1#d7e9",
      "id": "d6e9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seven: Building in Brooklyn")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2477"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c25_r1#d7e10",
      "id": "d6e10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eight: The Very Best")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2568"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c26_r1#d7e11",
      "id": "d6e11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Nine: Commandant")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2618"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c27_r1#d7e12",
      "id": "d6e12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Ten: Doctrines and Miracles")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2668"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c28_r1#d7e13",
      "id": "d6e13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Eleven: The Destiny of His State")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2718"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c29_r1#d7e14",
      "id": "d6e14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Twelve: I Must Continue")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2768"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c30_r1#d7e15",
      "id": "d6e15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Thirteen: A Hard-Pressed Debtor")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2828"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c31_r1#d7e16",
      "id": "d6e16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fourteen: Ancient Freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2878"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c32_r1#d7e17",
      "id": "d6e17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Fifteen: The Smell of Victory")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2928"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c33_r1#d7e18",
      "id": "d6e18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Sixteen: Our Duty to Live")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e2978"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c34_r1#d7e19",
      "id": "d6e19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Seventeen: An Affectionate Farewell")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    attrs: {
      "id": "d7e3028"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c35_r1#d7e20",
      "id": "d6e20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legacy")])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3078"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c36_r1#d7e21",
      "id": "d6e21",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3138"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c37_r1#d7e22",
      "id": "d6e22",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments ")])])])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "d7e3188"
    }
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/Perr_9781595554314_epub_c38_r1#d7e23",
      "id": "d6e23",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-567a69c3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Perr_9781595554314_epub_c15_r1.vue
// module id = 72
// module chunks = 0